import type { Component } from "vue";
import type { DecorationBinding } from "#ui/decoration/types";
import KsoPaySplit from "./ksoPaySplit/KsoPaySplit.vue";
import KsoPayText from "./ksoPayText/KsoPayText.vue";

export interface KsoPayControl {
	text: string;
	label: string;
	amount: string;
	labelAttrs: DecorationBinding;
	amountAttrs: DecorationBinding;
}

export const KSO_PAY_DEFAULT = "text";

export const ksoPayVariants: Record<string, Component> = {
	text: KsoPayText,
	split: KsoPaySplit,
};
